import React from "react";
import { ColorRing } from 'react-loader-spinner';
import { Typography } from 'antd';

const { Title } = Typography;

export const EmptyContent: React.FC<{message : string}> = props => {

  const {message} = props

  return (
    <>
    <div className="loader">
      <ColorRing
        height="200"
        width="200"
        ariaLabel="color-ring-loading"
        colors={['#d8b6fc', '#b5b4e9', '#7bb2c9', '#4cb1b0', '#25af9a']}
        wrapperStyle={{}}
        wrapperClass="circleLoader position-absolute top-50 start-50 translate-middle text-center z3"
        visible={true}
        />
        <Title level={4} className="circleLoader position-absolute top-50 start-50 translate-middle text-center z3 message-empty-page">{message}</Title>
        <div className="spinnerLoader vh-100 bg-white opacity-75" />
    </div>
    
    </>
  );
};